<div style="position: relative; height: 100vh !important; width: 100vw; background-color: white;">
    <div style="margin: 0;position: absolute; top: 45%; left: 50%; width: 300px !important; -ms-transform: translate(-50%, -50%) ; 
        transform: translate(-50%, -50%);">
        <div class="panel panel-default">
            <div class="panel-heading" style="text-align:center; background-color: rgb(254,252,234);">
                <!-- <img style="width:270px;" src="../../../assets/images/bsrm-logo.png"> -->
                <h3>Redirecting.....</h3> 
            </div>
            <div class="panel-body">
                <h4>{{message}}</h4>
            </div>
        </div>
           
    </div>
</div>